'use strict';
var wishlistHelper = require('base/product/wishlistHelper');


module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            e.preventDefault();
            var $this = $(this);
            var url = $(this).attr('href');
            var pid = $(this).closest('.product').data('pid');
            if (!url || !pid) {
                return;
            }
            var wishlistRenderURl = $(this).closest('.wishlist-my-account').data('render-href');
            var typeToRender = $(this).closest('.wishlist-my-account').data('type');
            $.spinner().start();
            wishlistHelper.wishListHandleClick($this, pid, url, null, true, function(){
                if(wishlistRenderURl){
                    wishlistHelper.rerenderWishList(wishlistRenderURl, typeToRender);
                }
            })
        });
    }
};
